import Avatar from "antd/lib/avatar";
import List from "antd/lib/list";
import Spin from "antd/lib/spin";
import sortBy from "lodash/sortBy";
import PropTypes from "prop-types";
import * as React from "react";

const MAX_CONNECTIONS = 5;

export default class CurrentUserConnections extends React.Component {
    static propTypes = {
        currentUserUid: PropTypes.string.isRequired,
        onToggleConnection: PropTypes.func.isRequired,
        togglingConnection: PropTypes.bool.isRequired,
        fetchingUsers: PropTypes.bool.isRequired,
        users: PropTypes.array
    };
    state = { currentPage: 1, pageSize: 7 };
    getPagination() {
        // Subtract one since the currentUser is not shown
        const total = this.props.users.length - 1;
        const lastPage = Math.ceil(total / this.state.pageSize);
        return {
            current:
                this.state.currentPage > lastPage
                    ? lastPage
                    : this.state.currentPage,
            pageSize: this.state.pageSize,
            total: total,
            onChange: nextPage => this.setState({ currentPage: nextPage }),
            size: "small",
            hideOnSinglePage: true
        };
    }
    getUsers(pagination) {
        const users = this.props.users.filter(
            user => user.id !== this.props.currentUserUid
        );
        const sliceStart = pagination.pageSize * (pagination.current - 1);
        const sliceEnd = sliceStart + pagination.pageSize;
        return sortBy(users, "name").slice(sliceStart, sliceEnd);
    }
    getRenderUser() {
        const currentUser = this.props.users.find(
            user => user.id === this.props.currentUserUid
        );
        if (!currentUser) {
            throw new Error("Expected currentUser to be amongst fetched users");
        }
        const canConnect =
            (currentUser.connections || []).length < MAX_CONNECTIONS;
        return user => {
            const isConnected =
                currentUser.connections &&
                currentUser.connections.includes(user.id);
            const action =
                canConnect || isConnected ? (
                    <a onClick={() => this.props.onToggleConnection(user.id)}>
                        {isConnected ? "Disconnect" : "Connect"}
                    </a>
                ) : (
                    undefined
                );
            return (
                <List.Item actions={[action]}>
                    <List.Item.Meta
                        avatar={<Avatar src={user.photoURL} />}
                        title={user.name}
                        description={
                            isConnected ? "Connected" : "Not connected"
                        }
                    />
                </List.Item>
            );
        };
    }
    renderList() {
        if (!this.props.users) {
            return null;
        }
        const pagination = this.getPagination();
        return this.props.users ? (
            <List
                itemLayout="horizontal"
                dataSource={this.getUsers(pagination)}
                renderItem={this.getRenderUser()}
                locale={{ emptyText: "No users" }}
                pagination={pagination}
                header={<h4>{"Connect with up to 5 colleagues"}</h4>}
            />
        ) : null;
    }
    render() {
        const spinning =
            (this.props.users && this.props.fetchingUsers) ||
            this.props.togglingConnection;
        return (
            <Spin spinning={spinning}>
                <div className="c-CurrentUserConnections">
                    {this.renderList()}
                </div>
            </Spin>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CurrentUserConnections/index.js